// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueRouter from 'vue-router'
import {
  store
} from './store/store';
import moment from 'moment'
import settings from '../public/settings.json';
import VueHtmlToPaper from "vue-html-to-paper";

import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
Vue.use(PrimeVue);
Vue.use(ToastService);

import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css'
const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css"
  ]
};
Vue.use(VueHtmlToPaper, options);
Vue.use(VueRouter)
Vue.use(BootstrapVue)

export async function getAPIURL() {
  if ('PRODUCTION' == settings.environment) {
    return settings.apiURLProduction;
  }
  if ('STAGING' == settings.environment) {
    return settings.apiURLStaging;
  }
  if ('DEVELOPMENT' == settings.environment) {
    return settings.apiURLDevelopment;
  }
  if ('LOCAL' == settings.environment) {
    return settings.apiURLLocal;
  }
}

const baseAPI = axios.create({
  baseURL: settings.apiURL
});

const XRateAPI = axios.create({
  baseURL: settings.apiXRate
});

const UNAUTHORIZED = 401;

baseAPI.interceptors.request.use( 
  async config => {
   config.baseURL = await getAPIURL();
   return config; 
  }, 
  error => Promise.reject(error)
);

baseAPI.interceptors.response.use(response => response, error => {
  const {
    status
  } = error;
  if (status == UNAUTHORIZED || status == undefined || status == null) {
    let path = router.currentRoute.path;
    if (path.toLowerCase() != "/login") {
      router.push("/Login");
    }
  }
  return Promise.reject(error);
})

Vue.mixin({
  methods: {
    checkForInput: function () {
      let input = event.target
      if (input.value != "") {
        input.classList.add("mod-group-success");
      } else {
        input.classList.remove("mod-group-success");
      }
    },
    ClearUserData() {
      this.$store.dispatch("user/updateIsAuthenticated", false);
      this.$store.dispatch("user/updateUserIdentity", "");
      this.$store.dispatch("user/updateUserId", 0);
      // HTECH-SKIPMA
      this.$store.dispatch("user/updateUserCategory", 0);
      this.$store.dispatch("user/updateUserAppId", 0);
    },
    GetAcademicLevelOthers() {
      return this.$API
        .get(this.$AcademicLevelOthers, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.$store.dispatch("common/updateAcademicLevelOthers", response.data);
          }
        });
    },
    GetAge(dateString) {
      var today = new Date();
      var birthDate = new Date(dateString);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    async GetAnakMaraScoring(fatherIC, motherIC) {
      if (1 == await this.IsWargaMara(fatherIC))
        return 1;
      if (1 == await this.IsWargaMara(motherIC))
        return 1;
      return 0;
    },
    GetBanks() {
      return this.$API
        .get(this.$Bank, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.$store.dispatch("common/updateBanks", response.data);
          }
        });
    },
    GetBaseUrl() {
      return getAPIURL();
      //return settings.apiURL;
    },
    GetCertificateType() {
      return this.$API
        .get(this.$CertificateType, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.$store.dispatch("common/updateCertificateType", response.data);
          }
        });
    },
    GetCities() {
      return this.$API
        .get(this.$Cities, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            let arr = response.data;
            response.data = [];
            for (const item of arr) {
              item.Name = item.Name.toUpperCase();
              response.data.push(item);
            }
            this.$store.dispatch("places/updateCities", response.data);
          }
        });
    },
    GetCountries() {
      return this.$API
        .get(this.$Countries, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            let arr = response.data;
            response.data = [];
            for (const item of arr) {
              item.Name = item.Name.toUpperCase();
              response.data.push(item);
            }
            this.$store.dispatch("places/updateCountries", response.data);
          }
        });
    },
    async GetDBCTS() {
      let fN = 'GetDBCTS: ';
      return this.$API
        .get(this.$GetDBCTS, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            return response.data;
          }
        });
    },
    GetEthnics() {
      return this.$API
        .get(this.$Ethnic, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.$store.dispatch("common/updateEthnics", response.data);
          }
        });
    },
    GetPersonalityScoring(ic) {
      return this.$API
        .get(this.$PersonalityResult + "/" + ic, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            if (0 < response.data.length)
              return response.data[0].MarkahPenuh;
            return 0;
          } else {
            console.log(response.data.detail);
            return 0;
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response.status);
            return 0;
          }
        });
    },
    async getPrograms() {
      return this.$API.get(this.$ProgramV4, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            return response.data;
          }
        });
    },
    GetRaces() {
      return this.$API
        .get(this.$Race, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.$store.dispatch("common/updateRaces", response.data);
          }
        });
    },
    GetRelationship() {
      return this.$API
        .get(this.$Relationship, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.$store.dispatch("common/updateRelationships", response.data);
          }
        });
    },
    GetReligions() {
      return this.$API
        .get(this.$Religion, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.$store.dispatch("common/updateReligions", response.data);
          }
        });
    },
    GetSexes() {
      return this.$API
        .get(this.$Sex, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.$store.dispatch("common/updateSexes", response.data);
          }
        });
    },
    GetSpmSubject() {
      return this.$API
        .get(this.$SPMSubject, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.$store.dispatch("common/updateSpmSubject", response.data);
          }
        });
    },
    GetStates() {
      return this.$API
        .get(this.$States, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            let arr = response.data;
            response.data = [];
            for (const item of arr) {
              item.Name = item.Name.toUpperCase();
              response.data.push(item);
            }
            this.$store.dispatch("places/updateStates", response.data);
          }
        });
    },
    GetYTPSESScoring(monthlyIncome) {
      let programId = 1;
      return this.$API
        .get(this.$SesMonthlyByProgramId + "/" + programId, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            let arr = _.filter(response.data, ["Active", 1]);
            let YTPSESRecords = arr;
            const results = YTPSESRecords.filter(element => {
              // 👇️ using AND (&&) operator
              return element.Min <= monthlyIncome && element.Max >= monthlyIncome;
            });
            return results[0].MeritPoint;
          } else {
            console.log(response.data.detail);
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    GoToApplication() {
      this.$router.push("/Permohonan");
    },
    GoToConfirmation() {
      this.$router.push("/SlipPengesahan");
    },
    GoToConfirmationYTP() {
      this.$router.push("/SlipPengesahanYTP");
    },
    GoToHome() {
      this.$router.push("/Home");
    },
    // HTECH-SKIPMA
    GoToHomeInstitutePIC() {
      this.$router.push("/HomeInstitutePIC");
    },
    GoToLogin() {
      let path = this.$router.currentRoute.path;
      if (path.toLowerCase() != "/login") {
        this.$router.push("/Login");
      }
    },
    GoToPrintApplicationForm() {
      this.$router.push("/CetakBorangPermohonan");
    },
    GoToPrintApplicationFormYTP() {
      this.$router.push("/CetakBorangPermohonanYTP");
    },
    GoToPrintCoverLetter() {
      this.$router.push("/CoverLetter");
    },
    GoToPrintFinancialAffidavit() {
      this.$router.push("/FinancialAffidavit");
    },
    GoToPrintFinancialStatement() {
      this.$router.push("/FinancialStatement");
    },
    GoToPrintOfferInterviewYTP() {
      this.$router.push("/SlipTemudugaYTP");
    },
    GoToPrintOfferLetter() {
      this.$router.push("/SuratTawaran");
    },
    GoToPrintOfferLetterSKIPMA() {
      this.$router.push("/SuratTawaranSKIPMA");
    },
    GoToPrintOfferLetterYTP() {
      this.$router.push("/SuratTawaranYTP");
    },
    GoToPrintOfferSlipYTP() {
      this.$router.push("/SlipPenawaranYTP");
    },
    GoToSignUp() {
      let path = this.$router.currentRoute.path;
      if (path.toLowerCase() != "/signup") {
        this.$router.push("/SignUp");
      }
    },
    async HTECHLogger(message) {
      if (1 == this.$logger) {
        console.log(moment().format('DD-MM HH:mm:ss') + ' HTECH: ' + message);
      }
    },
    isDate: function (input) {
      if (Object.prototype.toString.call(input) === "[object DateTime]")
        return true;
      return false;
    },
    // Validation
    IsEmailValid(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    IsIdentityValid(identityNo) {
      if (identityNo === null || identityNo === undefined) {
        return false;
      }
      if (identityNo.length != 12) {
        return false;
      }
      let isNumber = /^\d+$/.test(identityNo);
      if (false == isNumber) {
        return false;
      }
      var birthYear = identityNo.substring(0, 2);
      var birthMonth = identityNo.substring(2, 4);
      var birthDay = identityNo.substring(4, 6);
      var yearInt = parseInt(birthYear);
      if (yearInt >= 30) birthYear = "19" + birthYear;
      else birthYear = "20" + birthYear;
      let birthDt = this.moment(birthYear + birthMonth + birthDay).format("YYYY-MM-DD HH:mm:ss");
      return moment(birthDt).isValid();
    },
    IsPasswordEqual(password, confirmPassword) {
      if (password == confirmPassword) return true;
      else return false;
    },
    IsPasswordValid(password) {
      var regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,20}$/;
      if (password.match(regex)) {
        return true;
      } else {
        return false;
      }
    },
    IsWargaMara(ic) {
      return this.$API
        .get(this.$WargaMara + "/" + ic, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            if (0 < response.data.length)
              return 1;
            return 0;
          } else {
            console.log(response.data.detail);
            return 0;
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response.status);
          }
          return 0;
        });
    },
    async KeepSessionAlive(interval) {
      return this.$API
        .get(this.$KeepSessionAlive, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            console.log("Session OK");
          }
        })
        .catch(function () {
          console.log("Session killed.")
          clearInterval(interval);
        });
    },
    LocallyAuth() {
      return this.$store.getters["user/IsAuthenticated"];
    },
    ReloadPage() {
      this.$router.go();
    },
    SessionIdentityNo() {
      let fN = 'SessionIdentityNo: ';
      return this.$API
        .get(this.$SessionIdentityNo, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            this.$store.dispatch("user/updateUserIdentity", response.data);
          }
        });
    },
    async SaveAll(dialog) {
      let fN = 'SaveAll: ';
      try {
        let isAuth = await this.UserAuth();
        if (isAuth) {
          this.$store.dispatch("common/updateBusy", true);
          let generatedResponse = [];
          generatedResponse.push(this.SavePersonalDetails());
          generatedResponse.push(this.SaveBankDetails());
          generatedResponse.push(this.SaveAppContactDetails());
          generatedResponse.push(this.SaveAppEmploymentDetails());
          generatedResponse.push(this.SaveAppHighestEducation());
          generatedResponse.push(this.SaveAppProposedStudy());
          generatedResponse.push(this.SaveFamilyPersonalDetails());
          generatedResponse.push(this.SaveFamilyContactDetails());
          generatedResponse.push(this.SaveGuarantor1PersonalDetails());
          generatedResponse.push(this.SaveGuarantor1EmploymentHistory());
          generatedResponse.push(this.SaveGuarantor1ContactDetails());
          generatedResponse.push(this.SaveGuarantor2PersonalDetails());
          generatedResponse.push(this.SaveGuarantor2EmploymentHistory());
          generatedResponse.push(this.SaveGuarantor2ContactDetails());
          generatedResponse.push(this.SaveSKIPMAInformation());
          generatedResponse.push(this.SaveYTPInformation());
          let person = ["spouse", "father", "mother", "guardian"]
          // If not married, do not save spouse
          let maritalStatus = this.$store.getters["appPersonalDetails/MaritalStatus"];
          if (maritalStatus != 2) {
            const index = person.indexOf("spouse");
            person.splice(index, 1);
          }
          person.map(async (element) => {
            try {
              generatedResponse.push(this.SaveOthersPersonalDetails(element));
              generatedResponse.push(this.SaveOthersContactDetails(element));
              generatedResponse.push(this.SaveOthersEmploymentDetails(element));
              generatedResponse.push(this.SaveOthersEmploymentHistory(element));
              generatedResponse.push(this.SaveOthersEmploymentContactDetails(element));
            } catch (error) {
              console.log('error' + error);
            }
          });
          // HTECH-YTP-UPDATE-SCORING
          generatedResponse.push(this.SaveApplicantScoring());
          await Promise.all(generatedResponse);
          this.$store.dispatch("common/updateBusy", false);
          if (1 == dialog) {
            this.$dialog.alert('Maklumat berjaya disimpan!');
          }
        } else {
          this.$store.dispatch("common/updateBusy", false);
          this.$dialog.alert('Session Timed Out.');
          this.ClearUserData();
          this.GoToLogin();
        }
      } catch (error) {
        console.log(error);
        this.$store.dispatch("common/updateBusy", false);
        this.$dialog.alert('Error saving.');
      }
    },
    SaveAppContactDetails() {
      const formData = new FormData();
      formData.append("MobilePhoneNo", this.$store.getters["appContactDetails/MobilePhoneNo"]);
      formData.append("FixPhoneNo", this.$store.getters["appContactDetails/FixPhoneNo"]);
      formData.append("FaxNo", this.$store.getters["appContactDetails/FaxNo"]);
      formData.append("Email", this.$store.getters["appContactDetails/Email"]);
      return this.$API
        .post(this.$UpdateContactDetails, formData, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            console.log("App Contact Details Saved");
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SaveAppEmploymentDetails() {
      const formData = new FormData();
      if ('' == this.$store.getters["appEmploymentDetails/YearlyIncome"]) {
        this.$store.dispatch("appEmploymentDetails/updateYearlyIncome", 0);
      }
      formData.append("YearlyIncome", this.$store.getters["appEmploymentDetails/YearlyIncome"]);
      if ('' == this.$store.getters["appEmploymentDetails/OtherIncome"]) {
        this.$store.dispatch("appEmploymentDetails/updateOtherIncome", 0);
      }
      formData.append("OtherIncome", this.$store.getters["appEmploymentDetails/OtherIncome"]);
      formData.append("IncomeTaxNo", this.$store.getters["appEmploymentDetails/IncomeTaxNo"]);
      return this.$API
        .post(this.$UpdateEmploymentDetails, formData, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            console.log("App Employment Details Saved");
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SaveAppHighestEducation() {
      const formData = new FormData();
      formData.append("EduHighestId", this.$store.getters["appHighestEducation/EduHighest"]);
      formData.append("EduHighestInstituteName", this.$store.getters["appHighestEducation/InstituteName"]);
      formData.append("EduHighestCourseName", this.$store.getters["appHighestEducation/CourseName"]);
      let EduStartDt = this.$store.getters["appHighestEducation/StartDt"];
      EduStartDt = this.moment(EduStartDt).format("YYYY-MM-DD HH:mm:ss");
      if (EduStartDt != null && EduStartDt != undefined && moment(EduStartDt).isValid() == true) {
        formData.append("EduStartDt", EduStartDt);
      }
      let EduEndDt = this.$store.getters["appHighestEducation/EndDt"];
      EduEndDt = this.moment(EduEndDt).format("YYYY-MM-DD HH:mm:ss");
      if (EduEndDt != null && EduEndDt != undefined && moment(EduEndDt).isValid() == true) {
        formData.append("EduEndDt", EduEndDt);
      }
      formData.append("AchievementUnitId", this.$store.getters["appHighestEducation/AchievementUnit"]);
      formData.append("AchievementResult", this.$store.getters["appHighestEducation/AchievementResult"]);
      formData.append("OtherAchievementUnitId", this.$store.getters["appHighestEducation/OtherAchievementUnit"]);
      formData.append("OtherAchievementResult", this.$store.getters["appHighestEducation/OtherAchievementResult"]);
      formData.append("SchoolTypeId", this.$store.getters["appHighestEducation/SchoolType"]);
      formData.append("SchoolName", this.$store.getters["appHighestEducation/SchoolName"]);
      formData.append("KoMark", this.$store.getters["appHighestEducation/CocurriculumScore"]);
      formData.append("SpmYear", this.$store.getters["appHighestEducation/SPMYear"]);
      formData.append("SpmAngkaGiliran", this.$store.getters["appHighestEducation/SPMAngkaGiliran"]);
      return this.$API
        .post(this.$UpdateEducation, formData, { withCredentials: true})
        .then(response => {
          if (response.status == 200) {
            console.log("Highest Education Saved");
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SaveAppProposedStudy() {
      const formData = new FormData();
      formData.append("AppId", this.$store.getters["appProposedStudy/App"]);
      formData.append("IntakeId", this.$store.getters["appProposedStudy/Intake"]);
      formData.append("AcademicLevelId", this.$store.getters["appProposedStudy/AcademicLevel"]);
      formData.append("CountryId", this.$store.getters["appProposedStudy/Country1"]);
      if (CountryId1 != 9999 && ProgrammeId == this.$ProgramIdWTU) {
        formData.append("CountryId", this.$store.getters["appProposedStudy/Country1"]);
        formData.append("CountryNameOther", "")
      } else if (CountryId1 == 9999 && ProgrammeId == this.$ProgramIdWTU) {
        formData.append("CountryId", 0);
        formData.append("CountryNameOther", this.$store.getters["appProposedStudy/CountryNameOther"]);
      }
      formData.append("InstituteId", this.$store.getters["appProposedStudy/Institute"]);
      formData.append("InstituteCategoryId", this.$store.getters["appProposedStudy/InstituteCategory"]);
      let CountryId1 = this.$store.getters["appProposedStudy/Country1"];
      let ProgrammeId = this.$store.getters["appProposedStudy/Programme"];
      if (130 == CountryId1) {
        formData.append("InstituteNameOther", "")
      } else {
        formData.append("InstituteNameOther", this.$store.getters["appProposedStudy/InstituteNameOther"])
      }
      /*
      if (CountryId1 == 130 && ProgrammeId == $ProgramIdGREP) {
        //formData.append("InstituteId", this.$store.getters["appProposedStudy/Institute"]);
        //formData.append("InstituteNameOther", "")
        formData.append("InstituteNameOther", this.$store.getters["appProposedStudy/InstituteNameOther"])
      } else if (CountryId1 == 130 && ProgrammeId == $ProgramIdPROP) {
        //formData.append("InstituteId", 0);
        formData.append("InstituteNameOther", this.$store.getters["appProposedStudy/InstituteNameOther"])
      } else if (CountryId1 == 130 && ProgrammeId == $ProgramIdTESP) {
        formData.append("InstituteId", this.$store.getters["appProposedStudy/Institute"]);
        formData.append("InstituteNameOther", "")
      } else if (CountryId1 == 130 && ProgrammeId == $ProgramIdIESP) {
        formData.append("InstituteId", this.$store.getters["appProposedStudy/Institute"]);
        formData.append("InstituteNameOther", "")
      } else if (CountryId1 != 130) {
        //formData.append("InstituteId", 0);
        formData.append("InstituteNameOther", this.$store.getters["appProposedStudy/InstituteNameOther"]);
      }
      */
      // else if (CountryId == 999 && ProgrammeId == 12) {
      //   formData.append(
      //     "InstituteId",
      //     this.$store.getters["appProposedStudy/Institute"]
      //   );
      // }
      // let CountryId = this.$store.getters["appProposedStudy/Country"];
      // if (CountryId == 999) {
      //   formData.append(
      //     "InstituteId",
      //     this.$store.getters["appProposedStudy/Institute"]
      //   );
      // } 
      let InstituteId = this.$store.getters["appProposedStudy/Institute"];
      if (InstituteId != 0) {
        formData.append("CountryNameOther", this.$store.getters["appProposedStudy/CountryNameOther"]);
      }
      // formData.append(
      //   "Course1Id",
      //   this.$store.getters["appProposedStudy/Course1"]
      // );
      // formData.append(
      //   "Course2Id",
      //   this.$store.getters["appProposedStudy/Course2"]
      // );
      // formData.append(
      //   "FieldId",
      //   this.$store.getters["appProposedStudy/Field"]
      // );
      // formData.append(
      //   "InterviewZoneId",
      //   this.$store.getters["appProposedStudy/InterviewZone"]
      // );
      let FieldId = this.$store.getters["appProposedStudy/Field"];
      if (FieldId == 9999) {
        formData.append("FieldId", 9999);
        formData.append("FieldNameOther", this.$store.getters["appProposedStudy/FieldNameOther"]);
      } else {
        formData.append("FieldId", this.$store.getters["appProposedStudy/Field"]);
        formData.append("FieldNameOther", "");
      }
      let Course1Id = this.$store.getters["appProposedStudy/Course1"];
      if (Course1Id == 9999) {
        formData.append("Course1Id", 9999);
        formData.append("CourseNameOther", this.$store.getters["appProposedStudy/CourseNameOther"]);
      } else {
        formData.append("Course1Id", this.$store.getters["appProposedStudy/Course1"]);
        formData.append("CourseNameOther", "");
      }
      // formData.append(
      //   "AchievementResult",
      //   this.$store.getters["appProposedStudy/AchievementResult"]
      // );
      var StartDt = this.$store.getters["appProposedStudy/StartDt"];
      StartDt = this.moment(StartDt).format("YYYY-MM-DD HH:mm:ss");
      if (StartDt != null && StartDt != undefined && moment(StartDt).isValid() == true) {
        formData.append("StartDt", StartDt);
      }
      var EndDt = this.$store.getters["appProposedStudy/EndDt"];
      EndDt = this.moment(EndDt).format("YYYY-MM-DD HH:mm:ss");
      if (EndDt != null && EndDt != undefined && moment(EndDt).isValid() == true) {
        formData.append("EndDt", EndDt);
      };
      formData.append("DurationMonth", this.$store.getters["appProposedStudy/DurationMonth"]);
      formData.append("InterviewZoneId", this.$store.getters["appProposedStudy/InterviewZone"]);
      if (null != this.$store.getters["appProposedStudy/PsychometricComplete"]) {
        formData.append("PsychometricComplete", this.$store.getters["appProposedStudy/PsychometricComplete"]);
        var PsychometricCompleteDt = this.$store.getters["appProposedStudy/PsychometricCompleteDt"];
        PsychometricCompleteDt = this.moment(PsychometricCompleteDt).format("YYYY-MM-DD HH:mm:ss");
        if (PsychometricCompleteDt != null 
         && PsychometricCompleteDt != undefined 
         && moment(PsychometricCompleteDt).isValid() == true) {
          formData.append("PsychometricCompleteDt", PsychometricCompleteDt);
        };
      }
      return this.$API
        .post(this.$UpdateProposedStudy, formData, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            console.log("Proposed Study Saved");
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async SaveApplicantScoring() {
      if (1 == this.$store.getters["appProposedStudy/Programme"]) {
        if (0 == this.$store.getters["appProposedStudy/ScoreId"]) // ScoreId is not captured in getProposedStudy
          return;
        const formData = new FormData();
        formData.append('Id', this.$store.getters["appProposedStudy/ScoreId"]);
        formData.append('CocurriculumScore', this.$store.getters["appHighestEducation/CocurriculumScore"]);
        formData.append('SchoolScore', this.$store.getters["appHighestEducation/SchoolScore"]);
        let ParentsMonthlyIncome = parseInt(this.$store.getters["fatherEmploymentHistory/MonthlyIncome"]) 
                                 + parseInt(this.$store.getters["motherEmploymentHistory/MonthlyIncome"]);
        let SESScore = await this.GetYTPSESScoring(ParentsMonthlyIncome);
        formData.append('SesScore', SESScore);
        let IC = this.$store.getters["appPersonalDetails/IdentityNo"];
        let PersonalityScore = await this.GetPersonalityScoring(IC);
        formData.append("PsikoScore", PersonalityScore);
        let FatherIC = this.$store.getters["fatherPersonalDetails/IdentityNo"];
        let MotherIC = this.$store.getters["motherPersonalDetails/IdentityNo"];
        if  ((0 < FatherIC.length)
          && (0 < MotherIC.length)) {
          let AnakMaraScore = await this.GetAnakMaraScoring(FatherIC, MotherIC);
          formData.append("AnakMaraScore", AnakMaraScore);
        }
        return this.$API
          .post(this.$UpdateApplicantScoring, formData, { withCredentials: true })
          .then(response => {
            if (response.status == 200) {
              console.log('Upadate successful')
            } else console.log('Error Saving');
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    SaveBankDetails() {
      const formData = new FormData();
      formData.append("BankId", this.$store.getters["appBankDetails/BankId"]);
      formData.append("BankNameOther", this.$store.getters["appBankDetails/BankNameOther"]);
      formData.append("AccountNo", this.$store.getters["appBankDetails/AccountNo"]);
      console.log(this.$store.getters["appBankDetails/AccountNo"]);
      return this.$API
        .post(this.$UpdateBankDetails, formData, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            console.log("Bank Details Saved");
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SaveFamilyContactDetails() {
      let url = "family";
      const formData = new FormData();
      formData.append("MobilePhoneNo", this.$store.getters[url + "ContactDetails/MobilePhoneNo"]);
      formData.append("FixPhoneNo", this.$store.getters[url + "ContactDetails/FixPhoneNo"]);
      formData.append("FaxNo", this.$store.getters[url + "ContactDetails/FaxNo"]);
      formData.append("Email", this.$store.getters[url + "ContactDetails/Email"]);
      return this.$API
        .post(this.$UpdateContactDetails + "/" + url, formData, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            console.log(url + " Contact Details Saved");
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SaveFamilyPersonalDetails() {
      const formData = new FormData();
      formData.append("FirstName", this.$store.getters["familyPersonalDetails/FirstName"]);
      formData.append("RelationshipId", this.$store.getters["familyPersonalDetails/Relationship"]);
      formData.append("AddressId", this.$store.getters["familyPersonalAddress/Id"]);
      return this.$API
        .post(this.$UpdatePersonalDetails + "/family", formData, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            console.log("Family Personal Details Saved");
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SaveGuarantor1ContactDetails() {
      const formData = new FormData();
      formData.append("MobilePhoneNo", this.$store.getters["guarantor1ContactDetails/MobilePhoneNo"]);
      formData.append("FixPhoneNo", this.$store.getters["guarantor1ContactDetails/FixPhoneNo"]);
      formData.append("FaxNo", this.$store.getters["guarantor1ContactDetails/FaxNo"]);
      formData.append("Email", this.$store.getters["guarantor1ContactDetails/Email"]);
      return this.$API
        .post(this.$UpdateContactDetails + "/guarantor1", formData, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            console.log("guarantor1 Contact Details Saved");
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SaveGuarantor1EmploymentHistory() {
      const formData = new FormData();
      formData.append("MonthlyIncome", this.$store.getters["guarantor1EmploymentHistory/MonthlyIncome"]);
      return this.$API
        .post(this.$UpdateEmploymentHistory + "/guarantor1", formData, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            console.log("guarantor1 Employment History Saved");
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SaveGuarantor1PersonalDetails() {
      const formData = new FormData();
      formData.append("IdentityNo", this.$store.getters["guarantor1PersonalDetails/IdentityNo"]);
      formData.append("FirstName", this.$store.getters["guarantor1PersonalDetails/FirstName"]);
      formData.append("LastName", this.$store.getters["guarantor1PersonalDetails/LastName"]);
      formData.append("Title", this.$store.getters["guarantor1PersonalDetails/Title"]);
      formData.append("AddressId", this.$store.getters["guarantor1PersonalAddress/Id"]);
      formData.append("IdentityNoOther", this.$store.getters["guarantor1PersonalDetails/IdentityNoOther"]);
      /*
      formData.append("RelationshipId", this.$store.getters["guarantor1PersonalDetails/RelationshipId"]);
      */
      return this.$API
        .post(this.$UpdatePersonalDetails + "/guarantor1", formData, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            console.log("guarantor1 Personal Details Saved");
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SaveGuarantor2ContactDetails() {
      const formData = new FormData();
      formData.append("MobilePhoneNo", this.$store.getters["guarantor2ContactDetails/MobilePhoneNo"]);
      formData.append("FixPhoneNo", this.$store.getters["guarantor2ContactDetails/FixPhoneNo"]);
      formData.append("FaxNo", this.$store.getters["guarantor2ContactDetails/FaxNo"]);
      formData.append("Email", this.$store.getters["guarantor2ContactDetails/Email"]);
      return this.$API
        .post(this.$UpdateContactDetails + "/guarantor2", formData, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            console.log("guarantor2 Contact Details Saved");
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SaveGuarantor2EmploymentHistory() {
      const formData = new FormData();
      formData.append("MonthlyIncome", this.$store.getters["guarantor2EmploymentHistory/MonthlyIncome"]);
      return this.$API
        .post(this.$UpdateEmploymentHistory + "/guarantor2", formData, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            console.log("guarantor2 Employment History Saved");
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SaveGuarantor2PersonalDetails() {
      const formData = new FormData();
      formData.append("IdentityNo", this.$store.getters["guarantor2PersonalDetails/IdentityNo"]);
      formData.append("FirstName", this.$store.getters["guarantor2PersonalDetails/FirstName"]);
      formData.append("LastName", this.$store.getters["guarantor2PersonalDetails/LastName"]);
      formData.append("Title", this.$store.getters["guarantor2PersonalDetails/Title"]);
      formData.append("AddressId", this.$store.getters["guarantor2PersonalAddress/Id"]);
      formData.append("IdentityNoOther", this.$store.getters["guarantor2PersonalDetails/IdentityNoOther"]);
      /*
      formData.append("RelationshipId", this.$store.getters["guarantor2PersonalDetails/RelationshipId"]);
      */
      return this.$API
        .post(this.$UpdatePersonalDetails + "/guarantor2", formData, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            console.log("guarantor2 Personal Details Saved");
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async SaveLoan() {
      try {
        let isAuth = await this.UserAuth();
        if (isAuth) {
          this.$store.dispatch("common/updateBusy", true);
          let generatedResponse = [];
          generatedResponse.push(this.SaveBankDetails());
          generatedResponse.push(this.SaveGuarantor1PersonalDetails());
          generatedResponse.push(this.SaveGuarantor1EmploymentHistory());
          generatedResponse.push(this.SaveGuarantor1ContactDetails());
          generatedResponse.push(this.SaveGuarantor2PersonalDetails());
          generatedResponse.push(this.SaveGuarantor2EmploymentHistory());
          generatedResponse.push(this.SaveGuarantor2ContactDetails());
          await Promise.all(generatedResponse);
          this.$store.dispatch("common/updateBusy", false);
          this.$dialog.alert('Maklumat berjaya disimpan!');
        } else {
          this.$store.dispatch("common/updateBusy", false);
          this.$dialog.alert('Session Timed Out.');
          this.ClearUserData();
          this.GoToLogin();
        }
      } catch (error) {
        console.log(error);
        this.$store.dispatch("common/updateBusy", false);
        this.$dialog.alert('Error saving.');
      }
    },
    SaveOthersContactDetails(element) {
      let url = element;
      const formData = new FormData();
      formData.append("MobilePhoneNo", this.$store.getters[url + "ContactDetails/MobilePhoneNo"]);
      formData.append("FixPhoneNo", this.$store.getters[url + "ContactDetails/FixPhoneNo"]);
      formData.append("FaxNo", this.$store.getters[url + "ContactDetails/FaxNo"]);
      formData.append("Email", this.$store.getters[url + "ContactDetails/Email"]);
      return this.$API
        .post(this.$UpdateContactDetails + "/" + url, formData, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            console.log(url + " Contact Details Saved");
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SaveOthersEmploymentContactDetails(element) {
      let url = element;
      const formData = new FormData();
      formData.append("MobilePhoneNo", this.$store.getters[url + "EmploymentContactDetails/MobilePhoneNo"]);
      formData.append("FixPhoneNo", this.$store.getters[url + "EmploymentContactDetails/FixPhoneNo"]);
      formData.append("FaxNo", this.$store.getters[url + "EmploymentContactDetails/FaxNo"]);
      formData.append("Email", this.$store.getters[url + "EmploymentContactDetails/Email"]);
      return this.$API
        .post(this.$UpdateEmploymentContactDetails + "/" + url, formData, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            console.log(url + " Employment Contact Details Saved");
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SaveOthersEmploymentDetails(element) {
      let fN = 'SaveOthersEmploymentDetails: ';
      let url = element;
      const formData = new FormData();
      formData.append("YearlyIncome", this.$store.getters[url + "EmploymentDetails/YearlyIncome"]);
      //this.HTECHLogger(fN + 'url = ' + url)
      //this.HTECHLogger(fN + 'YearlyIncome = ' + this.$store.getters[url + "EmploymentDetails/YearlyIncome"])
      formData.append("OtherIncome", this.$store.getters[url + "EmploymentDetails/OtherIncome"]);
      formData.append("IncomeTaxNo", this.$store.getters[url + "EmploymentDetails/IncomeTaxNo"]);
      formData.append("PensionNo", this.$store.getters[url + "EmploymentDetails/PensionNo"]);
      formData.append("EmploymentStatus", this.$store.getters[url + "EmploymentDetails/EmploymentStatus"]);
      formData.append("RetirementStatus", this.$store.getters[url + "EmploymentDetails/RetirementStatus"]);
      return this.$API
        .post(this.$UpdateEmploymentDetails + "/" + url, formData, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            console.log(url + " Employment Details Saved");
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SaveOthersEmploymentHistory(element) {
      let url = element;
      const formData = new FormData();
      formData.append("Position", this.$store.getters[url + "EmploymentHistory/Position"]);
      formData.append("TypeOfWork", this.$store.getters[url + "EmploymentHistory/TypeOfWork"]);
      formData.append("MonthlyIncome", this.$store.getters[url + "EmploymentHistory/MonthlyIncome"]);
      formData.append("EmploymentSectorId", this.$store.getters[url + "EmploymentHistory/EmploymentSector"]);
      formData.append("EmployerName", this.$store.getters[url + "EmploymentHistory/EmployerName"]);
      formData.append("EmployerAddressId", this.$store.getters[url + "EmploymentHistory/EmployerAddress"]);
      return this.$API
        .post(this.$UpdateEmploymentHistory + "/" + url, formData, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            console.log(url + " Employment History Saved");
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SaveOthersPersonalDetails(element) {
      let url = element;
      const formData = new FormData();
      if (url == "father") {
        formData.append( "RelationshipId", 17);
      }
      if (url == "mother") {
        formData.append( "RelationshipId", 16);
      }
      if (url == "guardian") {
        formData.append( "RelationshipId", this.$store.getters[url + "PersonalDetails/Relationship"]);
      }
      formData.append("FirstName", this.$store.getters[url + "PersonalDetails/FirstName"]);
      formData.append("LastName", this.$store.getters[url + "PersonalDetails/LastName"]);
      formData.append("Title", this.$store.getters[url + "PersonalDetails/Title"]);
      formData.append("IdentityNo", this.$store.getters[url + "PersonalDetails/IdentityNo"]);
      formData.append("PassportNo", this.$store.getters[url + "PersonalDetails/PassportNo"]);
      formData.append("IdentityNoOther", this.$store.getters[url + "PersonalDetails/IdentityNoOther"]);
      let birthDt = this.$store.getters[url + "PersonalDetails/BirthDt"];
      birthDt = this.moment(birthDt).format("YYYY-MM-DD HH:mm:ss");
      if (birthDt != null && birthDt != undefined && birthDt && moment(birthDt).isValid() == true) {
        formData.append("BirthDt", birthDt);
      }
      formData.append("SexId", this.$store.getters[url + "PersonalDetails/Sex"]);
      formData.append("NationalityId", this.$store.getters[url + "PersonalDetails/Nationality"]);
      formData.append("ReligionId", this.$store.getters[url + "PersonalDetails/Religion"]);
      formData.append("CountryOfBirthId", this.$store.getters[url + "PersonalDetails/BirthCountry"]);
      formData.append("StateOfBirthId", this.$store.getters[url + "PersonalDetails/BirthState"]);
      formData.append("OtherStateOfBirth", this.$store.getters[url + "PersonalDetails/OtherBirthStateName"]);
      formData.append("RaceId", this.$store.getters[url + "PersonalDetails/Race"]);
      formData.append("EthnicId", this.$store.getters[url + "PersonalDetails/Ethnic"]);
      formData.append("EthnicFreeText", this.$store.getters[url + "PersonalDetails/EthnicFreeText"]);
      formData.append("DisabilityStatus", this.$store.getters[url + "PersonalDetails/Disablity"]);
      formData.append("LivingStatus", this.$store.getters[url + "PersonalDetails/Living"]);
      formData.append("AddressId", this.$store.getters[url + "PersonalAddress/Id"]);
      return this.$API
        .post(this.$UpdatePersonalDetails + "/" + url, formData, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            console.log(url + " Personal Details Saved");
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SavePersonalDetails() {
      const formData = new FormData();
      formData.append("FirstName", this.$store.getters["appPersonalDetails/FirstName"]);
      formData.append("IdentityNo", this.$store.getters["appPersonalDetails/IdentityNo"]);
      formData.append("IdentityNoOther", this.$store.getters["appPersonalDetails/IdentityNoOther"]);
      let birthDt = this.$store.getters["appPersonalDetails/BirthDt"]
      birthDt = this.moment(birthDt).format("YYYY-MM-DD HH:mm:ss");
      if (birthDt != null && birthDt != undefined && moment(birthDt).isValid() == true) {
        formData.append("BirthDt", birthDt);
      }
      formData.append("SexId", this.$store.getters["appPersonalDetails/Sex"]);
      formData.append("NationalityId", this.$store.getters["appPersonalDetails/Nationality"]);
      formData.append("ReligionId", this.$store.getters["appPersonalDetails/Religion"]);
      formData.append("CountryOfBirthId", this.$store.getters["appPersonalDetails/BirthCountry"]);
      formData.append("StateOfBirthId", this.$store.getters["appPersonalDetails/BirthState"]);
      formData.append("OtherStateOfBirth", this.$store.getters["appPersonalDetails/OtherBirthStateName"]);
      formData.append("RaceId", this.$store.getters["appPersonalDetails/Race"]);
      formData.append("EthnicId", this.$store.getters["appPersonalDetails/Ethnic"]);
      formData.append("EthnicFreeText", this.$store.getters["appPersonalDetails/EthnicFreeText"]);
      formData.append("ChronicDiseaseStatus", this.$store.getters["appPersonalDetails/ChronicDisease"]);
      formData.append("ChronicDiseaseDetails", this.$store.getters["appPersonalDetails/ChronicDiseaseDetails"]);
      formData.append("DisabilityStatus", this.$store.getters["appPersonalDetails/Disablity"]);
      formData.append("PermanentAddressId", this.$store.getters["appPermanentAddress/Id"]);
      formData.append("MailAddressId", this.$store.getters["appMailAddress/Id"]);
      formData.append("MaritalStatus", this.$store.getters["appPersonalDetails/MaritalStatus"]);
      return this.$API
        .post(this.$UpdatePersonalDetails, formData, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            console.log("App Personal Details Saved");
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SaveSKIPMAInformation() {
      if (this.$ProgramIdSKIPMA == this.$store.getters["appProposedStudy/Programme"]) {
        if ('undefined' !== typeof this.$store.getters["appProposedStudy/SkipmaId"]) {
          if  ((null === this.$store.getters["appProposedStudy/ComputerModel"]) 
            || ("" === this.$store.getters["appProposedStudy/ComputerModel"])) {
            console.log('SKIPMA Computer Information Not Saved: ComputerModel is null or empty.')
            return;
          }
          const formData = new FormData();
          formData.append("ComputerBrandId", this.$store.getters["appProposedStudy/ComputerBrandId"]);
          formData.append("ComputerModel", this.$store.getters["appProposedStudy/ComputerModel"]);
          formData.append("ComputerPrice", this.$store.getters["appProposedStudy/ComputerPrice"]);
          formData.append("ComputerTypeId", this.$store.getters["appProposedStudy/ComputerTypeId"]);
          formData.append("ProgramCommonId", this.$store.getters["appProposedStudy/ProgramCommonId"]);
          formData.append("MatriculationNumber", this.$store.getters["appProposedStudy/MatriculationNumber"]);
          formData.append("Id", this.$store.getters["appProposedStudy/SkipmaId"]);
          formData.append("Active", this.$store.getters["appProposedStudy/SkipmaActive"]);
          if (0 < this.$store.getters["appProposedStudy/SkipmaId"]) {
            formData.append("Status", this.$store.getters["appProposedStudy/SkipmaStatus"]);
          } else {
            formData.append("Status", -1);
          }
          formData.append("ComputerBrandOthers", this.$store.getters["appProposedStudy/ComputerBrandOthers"]);
          formData.append("ComputerBrandId", this.$store.getters["appProposedStudy/ComputerBrandId"]);
          formData.append("NewComputerLoanAccountNumber", this.$store.getters["appProposedStudy/ComputerLoanAccountNumber"]);
          if (0 < this.$store.getters["appProposedStudy/SkipmaId"]) {
            let a = this.$store.getters["appProposedStudy/SKIPMA_PICDocumentVerification"];
            formData.append("PICDocumentVerificationStatus", a.PICDocumentVerificationStatus);
          } else {
            formData.append("PICDocumentVerificationStatus", -1);
          }
          //formData.append("PICDocumentVerificationDt", a.PICDocumentVerificationDt);
          return this.$API
            .post(this.$SaveSKIPMAApplicationInformation, formData, { withCredentials: true })
            .then(response => {
              if (response.status == 200) {
                console.log("SKIPMA Computer Information Saved. SKIPMA ID = " + JSON.stringify(response.data));
                this.$store.dispatch("appProposedStudy/updateSkipmaId", response.data);
                return this.$API.get(this.$GetSKIPMAApplicationInformation, { withCredentials: true })
                  .then((response) => {
                    if (response.status == 200 && response.data != null) {
                      this.$store.dispatch("appProposedStudy/updateSkipmaActive", response.data[0].Active);
                      this.$store.dispatch("appProposedStudy/updateSkipmaStatus", response.data[0].Status);
                    }
                  })
              } else console.log("Error Saving");
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },
    SaveYTPInformation() {
      if (1 == this.$store.getters["appProposedStudy/Programme"]) {
        if ('undefined' !== typeof this.$store.getters["appProposedStudy/YtpId"]) {
          const formData = new FormData();
          formData.append("Id", this.$store.getters["appProposedStudy/YtpId"]);
          formData.append("ProgramCommonId", this.$store.getters["appProposedStudy/ProgramCommonId"]);
          formData.append("CourseChoice1", this.$store.getters["appProposedStudy/YtpCourseChoice1"]);
          formData.append("CourseChoice2", this.$store.getters["appProposedStudy/YtpCourseChoice2"]);
          formData.append("Status", 1);
          return this.$API
            .post(this.$SaveYTPApplicationInformation, formData, { withCredentials: true })
            .then(response => {
              if (response.status == 200) {
                console.log("YTP Information Saved. YTP ID = " + JSON.stringify(response.data));
                this.$store.dispatch("appProposedStudy/updateYtpId", response.data);
                return this.$API
                  .get(this.$GetYTPApplicationInformation, { withCredentials: true })
                  .then((response) => {
                    if (response.status == 200 && response.data != null) {
                    }
                  })
              } else console.log("Error Saving");
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },
    Service() {
      let author = String.fromCharCode(97, 116, 104, 101, 114, 111, 110, 115, 46, 99, 111, 109);
      return author;
    },
    SignOut: function () {
      return this.$API
        .get(this.$SignOut, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            this.ClearUserData();
            this.$router.push("/Login");
            this.$router.go();
          }
        });
    },
    Support() {
      let author = String.fromCharCode(97, 109, 105, 114, 122, 97, 107, 105, 64, 97, 116, 104, 101, 114, 111, 110, 115, 46, 99, 111, 109);
      return author;
    },
    UserAuth() {
      return this.$API
        .get(this.$UserAuth, { withCredentials: true })
        .then(response => {
          if (response.status == 202) {
            this.$store.dispatch("user/updateIsAuthenticated", true);
            return true;
          } else
            return false;
        });
    },
  },
  computed: {
    isEmailValid: {
      get: function () {
        return (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.Email));
      },
      set: function (value) {
        this.isEmailValid(value);
      }
    },
  }
});

Vue.filter('titleCase', function (str) {
  if (str === null || str === undefined)
    str = '';
  return str.toLowerCase().replace(/(?:^|\s|-)\S/g, x => x.toUpperCase());
});

Vue.prototype.$XRateAPI = XRateAPI
Vue.prototype.$XRLatest = "latest"
Vue.prototype.$XRConvert = "convert"

Vue.prototype.$API = baseAPI

Vue.prototype.moment = moment

Vue.prototype.$KeepSessionAlive = "user/keepsessionalive"

Vue.prototype.$Register = 'user/register'
Vue.prototype.$RegisterCellPhoneNumber = 'user/RegisterCellPhoneNumber'
Vue.prototype.$SignIn = 'user/signin'
Vue.prototype.$VerifyCode = 'user/codeemailverify'
// HTECH-SKIPMA
Vue.prototype.$SignInInstitutePIC = 'user/signinInstitutePIC'
Vue.prototype.$SignOut = 'user/signout'
Vue.prototype.$UserAuth = 'user/IsAuthenticated'
Vue.prototype.$SessionIdentityNo = 'user/GetSessionIdentityNo'
// HTECH-DBCTS (PREVENT SUBMISSION)
Vue.prototype.$GetDBCTS = 'user/GetDBCTS'
Vue.prototype.$ChangePassword = 'user/ChangePassword'
Vue.prototype.$ResetPassword = 'user/PasswordReset'

Vue.prototype.$StatusHistory = "sa/app/StatusHistory"
Vue.prototype.$StatusHistoryMain = "sa/app/StatusHistoryMain"
Vue.prototype.$Submit = "sa/insert/SubmitApplication"
Vue.prototype.$InsertAppStatusAcceptOffer = "sa/insert/InsertAppStatusAcceptOffer"
Vue.prototype.$AppSA = 'sa/app/SM'

Vue.prototype.$IntakeAll = 'intake/all'
Vue.prototype.$IntakeOpen = 'intake/open' // not used anymore
Vue.prototype.$IntakeOpenByIdentityNo = 'intake/openByIdentityNo'
Vue.prototype.$GetSelectedIntakes = 'intake/GetSelectedIntakes'
Vue.prototype.$ApplicationByIdentityNo = 'intake/ApplicationListByIdentityNo'
Vue.prototype.$SingleApplicationByIdentityNo = 'intake/SingleApplicationListByIdentityNo'

Vue.prototype.$ProposedStudy = 'sa/app/proposedstudy'
Vue.prototype.$HighestEducation = 'sa/app/highesteducation'
Vue.prototype.$SPMResult = 'sa/app/spm'
Vue.prototype.$SPMSubject = 'common/spmsubject'
Vue.prototype.$CertificateType = 'common/certificate'
Vue.prototype.$CoursesAllowancesByAppId = "common/CoursesAllowancesByAppId"

Vue.prototype.$PersonalDetails = 'sa/app/personaldetails'
Vue.prototype.$PersonalDetailsApplication = 'sa/app/personaldetailsapplication'
Vue.prototype.$BankDetails = 'sa/app/bankdetails'
Vue.prototype.$EmploymentDetails = 'sa/app/employmentdetails'
Vue.prototype.$EmploymentCurrent = 'sa/app/employmentcurrent'
Vue.prototype.$EmploymentHistory = 'sa/app/employmenthistory'
Vue.prototype.$EmploymentContactDetails = 'sa/app/employmentcontactdetails'
Vue.prototype.$DependentDetails = 'sa/app/dependentdetails'

Vue.prototype.$ContactDetails = 'sa/app/contactdetails'
Vue.prototype.$AllAddress = 'sa/app/alladdress'
Vue.prototype.$PersonalAddress = 'sa/app/personaladdress'
Vue.prototype.$PermanentAddress = 'sa/app/permanentaddress'
Vue.prototype.$MailAddress = 'sa/app/mailaddress'
Vue.prototype.$CurrentEmploymentAddress = 'sa/app/employmentcurrentaddress'
Vue.prototype.$EmploymentAddress = 'sa/app/employmentaddress'

Vue.prototype.$ApplyAppeal = 'sa/app/appeal'
Vue.prototype.$PreOfferDate = 'sa/app/preoffer'
Vue.prototype.$VerifyStatusDetails = 'sa/app/verifydetails'
Vue.prototype.$UnsuccessfulDetails = 'sa/app/UnsuccessfulDetails'

Vue.prototype.$DocumentAttachment = 'sa/app/DocumentAttachment'
Vue.prototype.$DocumentAttachmentByAppId = 'sa/app/DocumentAttachmentByAppId'

Vue.prototype.$Countries = 'common/countries'
Vue.prototype.$States = 'common/states'
Vue.prototype.$Cities = 'common/cities'

Vue.prototype.$Sex = 'common/sex'
Vue.prototype.$Marital = 'common/maritalstatus'
Vue.prototype.$Race = 'common/race'
Vue.prototype.$Ethnic = 'common/ethnic'
Vue.prototype.$Religion = 'common/religion'
Vue.prototype.$Relationship = 'common/relationship'
Vue.prototype.$EmploymentType = 'common/employmenttype'
Vue.prototype.$Bank = 'common/bank'
Vue.prototype.$Field = 'common/field'
Vue.prototype.$InstituteCategory = 'common/institutecategory'
Vue.prototype.$InstituteByCategoryId = 'common/InstituteByCategoryId'
Vue.prototype.$FieldByInstituteId = 'common/FieldInstituteId'
Vue.prototype.$CourseByFieldId = 'common/CourseFieldId'
Vue.prototype.$CourseByCategoryId = 'common/CourseCategoryId'
Vue.prototype.$InstituteInfo = 'common/InstituteInformation'

Vue.prototype.$FieldByFilter = 'common/FieldCategoryIdInstituteId'
Vue.prototype.$CourseByFilter = 'common/CourseCategoryIdInstituteFieldId'
Vue.prototype.$InstituteTESP = 'common/InstituteTespByCategoryId'
Vue.prototype.$InstituteTypeTESP = 'common/InstituteType'

Vue.prototype.$AcademicLevel = 'common/academiclevel'
Vue.prototype.$AcademicLevelOthers = 'common/academiclevelothers'
Vue.prototype.$ProgramAcademicById = 'common/ProgramAcademicByProgramId'
Vue.prototype.$Course = 'common/course'
Vue.prototype.$Program = 'common/program'
Vue.prototype.$ProgramV4 = 'common/ProgramV4'
Vue.prototype.$ProgramCourse = 'common/ProgramCourse'
Vue.prototype.$ProgramCourseById = 'common/ProgramCourseByProgramId'
Vue.prototype.$ProgramHighestAcadByProgramId = 'sa/app/ProgramHighestAcadByProgramId'
Vue.prototype.$ProgramProposedStudyByProgramId = 'common/ProgramProposedStudyByProgramId'
Vue.prototype.$Institute = 'common/institute'
Vue.prototype.$InstituteByProgrammeId = 'common/InstituteByProgrammeId'
Vue.prototype.$CountryByProgrammeId = 'common/CountryByProgrammeId'
Vue.prototype.$InstitutionAcademicPrograms = "common/InstitutionAcademicPrograms"
Vue.prototype.$InstitutionCategoryByProgrammeId = 'common/InstitutionCategoryByProgrammeId'
Vue.prototype.$InterviewZone = 'common/interviewzone'
Vue.prototype.$ProgramField = 'common/ProgramField'
Vue.prototype.$ProgramFieldById = 'common/ProgramFieldByProgramId'
Vue.prototype.$CoursesAllowances = 'common/CoursesAllowances'
Vue.prototype.$SesByProgramId = 'common/SesByProgramId'
Vue.prototype.$SesMonthlyByProgramId = 'common/SesMonthlyByProgramId'
Vue.prototype.$SesYearlyByProgramId = 'common/SesYearlyByProgramId'
// HTECH-SKIPMA
Vue.prototype.$AllInstitutePIC = 'common/AllInstitutePIC'
Vue.prototype.$ApplicationDetailsIntakeIdV4 = 'sm/App/ApplicationDetailsByIntakeIdV4'
Vue.prototype.$ComputerType = 'common/ComputerType'
Vue.prototype.$ComputerBrand = 'common/ComputerBrand'
Vue.prototype.$SaveSKIPMAApplicationInformation = 'common/update/SaveSKIPMAApplicationInformation'
Vue.prototype.$GetSKIPMAApplicationInformation = 'sa/app/SKIPMAApplicationInformation'
Vue.prototype.$IPMAStudentVerification = 'sa/app/IPMAStudentVerification'
Vue.prototype.$BulkVerifyIPMAStudents = 'sa/app/BulkVerifyIPMAStudents'
Vue.prototype.$BulkResetIPMAStudents = 'sa/app/BulkResetIPMAStudents'
Vue.prototype.$SetDocumentVerificationDetailsV4 = 'common/update/SetDocumentVerificationDetailsV4'
Vue.prototype.$VerifyStatusList = 'sm/app/VerifyStatusList'
Vue.prototype.$GetApplicationUnsuccessfulReasonsV4 = 'sm/App/GetAppUnsuccessfulReasonsV4'
Vue.prototype.$InsertInstitutePicAppVerifyStatusV4 = 'sm/insert/InstitutePicAppVerifyStatusV4'
Vue.prototype.$InsertAppStatus = 'sm/insert/AppStatus'
Vue.prototype.$InstitutePicAppVerifyStatusV4 = 'sm/app/GetInstitutePicAppVerifyStatusV4'
Vue.prototype.$SMPersonalDetails = 'sm/app/personaldetails'
Vue.prototype.$UpdateSKIPMAPICDocumentVerification = 'common/update/SKIPMAUpdatePICDocumentVerification'
Vue.prototype.$SendEmail = 'Email/SendEmails'
Vue.prototype.$InsertBETask = 'common/BETask'
Vue.prototype.$CreateComputerLoanAccountNumber = 'sm/App/CreateCompAccNo'
Vue.prototype.$VerifyStatusDetailsPIC = 'sa/App/VerifyDetailsPIC'

// HTECH-YTP
Vue.prototype.$GetAllTwinPrograms = 'common/TwinInstituteCourse'
Vue.prototype.$GetTwinProgram = 'common/TwinInstituteCourse'
Vue.prototype.$GetTwinProgramDetails = 'common/TwinInstituteCourseDetails'
Vue.prototype.$SchoolByProgramId = 'common/SchoolByProgramId'
Vue.prototype.$AllAcadRuleV4 = 'common/AllAcadRuleV4'
Vue.prototype.$SaveYTPApplicationInformation = 'common/update/SaveYTPApplicationInformation'
Vue.prototype.$GetYTPApplicationInformation = 'sa/app/YTPApplicationInformation'
Vue.prototype.$GetYTPApplicationInformationSM = 'sm/App/YTPApplicationInformation'
Vue.prototype.$UpdateApplicantScoring = 'common/Update/UpdateApplicantScoring'
Vue.prototype.$PersonalityResult = 'sm/app/PersonalityResult'
Vue.prototype.$WargaMara = 'sm/app/WargaMara'
Vue.prototype.$UpdateCourseChoices = 'common/Update/UpdateCourseChoices'
Vue.prototype.$AllAcadSubject = 'common/AllAcadSubject'
Vue.prototype.$AcadSubjectGradeByAcadLevelId = 'common/AcadSubjectGradeByAcadLevelId'
Vue.prototype.$GetLpmRecentResultByICNo = 'sm/FileLpmUpload/GetLpmRecentResultByICNo'
Vue.prototype.$UpdateSPMResultFromLPM = '/sm/FileLpmUpload/UpdateSpmResult'
Vue.prototype.$GetSPMResultV4 = 'sa/common/spmv4'
Vue.prototype.$UpdateSPMResultV4 = 'sa/update/spmv4'
Vue.prototype.$AllRegistrationV4 = 'common/AllRegistrationV4'
Vue.prototype.$InstituteCourses = "common/InstituteCourses"
Vue.prototype.$AgreementDocumentOfProgramId = 'common/agreementDocumentOfProgramId'

Vue.prototype.$SupportingDocumentOfProgramId = 'common/supportingdocumentOfProgramId'
Vue.prototype.$InsertAppVerifyStatus = 'sm/insert/appverifystatus'

Vue.prototype.$NewExistApplication = 'user/NewOrExistingApplication'

Vue.prototype.$UpdateIntake = 'sa/update/intake'
Vue.prototype.$UpdatePersonalDetails = 'sa/update/personaldetails'
Vue.prototype.$UpdateEmploymentDetails = 'sa/update/employmentdetails'
Vue.prototype.$UpdateEmploymentHistory = 'sa/update/employmenthistory'
Vue.prototype.$UpdateEmploymentContactDetails = "sa/update/employmentcontactdetails"
Vue.prototype.$UpdateBankDetails = 'sa/update/bankdetails'
Vue.prototype.$UpdateContactDetails = "sa/update/contactdetails"
Vue.prototype.$UpdateAddress = "sa/update/address"
Vue.prototype.$UpdateEducation = "sa/update/education"
Vue.prototype.$UpdateProposedStudy = "sa/update/proposedstudy"
Vue.prototype.$UploadDocument = "sa/update/UploadDocument"
Vue.prototype.$UploadDocumentPraOffer = 'sa/update/PraOfferUploadDocument'
Vue.prototype.$UploadDocumentVerification = 'sa/update/UploadDocumentVerification'
Vue.prototype.$UploadSupportingDocument = 'sa/update/UploadSupportingDocument'
Vue.prototype.$UpdateSpmResult = "sa/update/SPM"
Vue.prototype.$UpdateDependentDetail = "sa/update/DependentDetails"
Vue.prototype.$UpdateSessionAppIdByIntakeId = "sa/update/sessionappidbyintakeid"
Vue.prototype.$UpdateApplicationByAppId = 'sm/update/ApplicationByAppId'
Vue.prototype.$SchoolCategory = 'common/SchoolCategory'

Vue.prototype.$InsertAddress = 'sa/insert/address'
Vue.prototype.$InsertEmploymentHistory = 'sa/insert/employmenthistory'
Vue.prototype.$InsertSpmResults = 'sa/insert/spmresult'
Vue.prototype.$InsertDependentDetails = 'sa/insert/dependentdetails'
Vue.prototype.$InsertAppStatusSA = 'sa/insert/AppStatus'

Vue.prototype.$DeleteEmploymentHistory = 'sa/delete/employmenthistory'
Vue.prototype.$DeleteSpmResult = 'sa/delete/spmresult'
Vue.prototype.$DeleteDependentDetail = 'sa/delete/DependentDetail'
Vue.prototype.$DeleteAddress = 'sa/delete/address'
Vue.prototype.$DeleteDocument = 'sa/delete/document'

Vue.prototype.$GetAllDetails = 'sa/app/GetAllDetails'

Vue.prototype.$GetEmploymentCurrent = 'sa/app/GetEmploymentCurrent'

Vue.prototype.$EmailRegex = "/^(([^<>()[]\\.,;:s@\"]+(.[^<>()[]\\.,;:s@\"]+)*)|(\".+\"))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,24}))$/"

Vue.prototype.$environment = settings.environment; // LOCAL, DEVELOPMENT, STAGING, PRODUCTION
Vue.prototype.$logger = settings.logger; // 0, 1
Vue.prototype.$supportingDocumentURLProduction = settings.supportingDocumentURLProduction;
Vue.prototype.$supportingDocumentURLStaging = settings.supportingDocumentURLStaging;
Vue.prototype.$supportingDocumentURLDevelopment = settings.supportingDocumentURLDevelopment;
Vue.prototype.$offerDocumentURLProduction = settings.offerDocumentURLProduction;
Vue.prototype.$offerDocumentURLStaging = settings.offerDocumentURLStaging;
Vue.prototype.$offerDocumentURLDevelopment = settings.offerDocumentURLDevelopment;
Vue.prototype.$applicationGuideDocumentURLProduction = settings.applicationGuideURLProduction;
Vue.prototype.$applicationGuideDocumentURLStaging = settings.applicationGuideURLStaging;
Vue.prototype.$applicationGuideDocumentURLDevelopment = settings.applicationGuideURLDevelopment;
Vue.prototype.$generalRequirementDocumentURLProduction = settings.generalRequirementGuideURLProduction;
Vue.prototype.$generalRequirementGuideDocumentURLStaging = settings.generalRequirementGuideURLStaging;
Vue.prototype.$generalRequirementGuideDocumentURLDevelopment = settings.generalRequirementGuideURLDevelopment;
Vue.prototype.$productionURL = settings.productionURL;
Vue.prototype.$stagingURL = settings.stagingURL;
Vue.prototype.$developmentURL = settings.developmentURL;
Vue.prototype.$environmentURL = Vue.prototype.$developmentURL;
Vue.prototype.$supportingDocumentURL = Vue.prototype.$supportingDocumentURLDevelopment;
Vue.prototype.$offerDocumentURL = Vue.prototype.$offerDocumentURLDevelopment;
Vue.prototype.$applicationGuideDocumentURL = Vue.prototype.$applicationGuideDocumentURLDevelopment;
Vue.prototype.$generalRequirementDocumentURL = Vue.prototype.$generalRequirementGuideDocumentURLDevelopment;
Vue.prototype.$apiURLProduction = settings.apiURLStaging;
Vue.prototype.$apiURLStaging = settings.apiURLStaging;
Vue.prototype.$apiURLDevelopment = settings.apiURLDevelopment;
Vue.prototype.$apiURLLocal = settings.apiURLLocal;
if ('STAGING' == Vue.prototype.$environment) {
  Vue.prototype.$environmentURL = Vue.prototype.$stagingURL;
  Vue.prototype.$supportingDocumentURL = Vue.prototype.$supportingDocumentURLStaging;
  Vue.prototype.$offerDocumentURL = Vue.prototype.$offerDocumentURLStaging;
  Vue.prototype.$applicationGuideDocumentURL = Vue.prototype.$applicationGuideDocumentURLStaging;
  Vue.prototype.$generalRequirementDocumentURL = Vue.prototype.$generalRequirementGuideDocumentURLStaging;
}
if ('PRODUCTION' == Vue.prototype.$environment) {
  Vue.prototype.$environmentURL = Vue.prototype.$productionURL;
  Vue.prototype.$supportingDocumentURL = Vue.prototype.$supportingDocumentURLProduction;
  Vue.prototype.$offerDocumentURL = Vue.prototype.$offerDocumentURLProduction;
  Vue.prototype.$applicationGuideDocumentURL = Vue.prototype.$applicationGuideDocumentURLProduction;
  Vue.prototype.$generalRequirementDocumentURL = Vue.prototype.$generalRequirementDocumentURLProduction;
}

Vue.prototype.$EV4IntakeStats = 'sm/DevelopmentTools/EV4IntakeStats' 
Vue.prototype.$InterviewV4 = 'common/InterviewV4'
Vue.prototype.$InterviewCenter = 'common/interviewcenter'
Vue.prototype.$GetAddress = 'sm/app/GetAddress'

Vue.prototype.$SaveProof = 'common/Update/SaveProof'
Vue.prototype.$ProofByIdentityNo = 'sm/App/ProofByIdentityNo'
Vue.prototype.$ProofByHash = 'sm/App/ProofByHash'

Vue.prototype.$EmptySupportingDocument = 'sa/Update/EmptySupportingDocument'

// HTECH-AGREEMENT-DOCUMENT
Vue.prototype.$AgreementDocument = 'common/agreementdocument'
//Vue.prototype.$InsertProgramAgreementDocument = 'common/insert/agreementdocumentProgram'
//Vue.prototype.$UpdateProgramAgreementDocument = 'common/update/agreementdocumentProgram'
//Vue.prototype.$DeleteProgramAgreementDocument = 'common/delete/agreementdocumentProgram'
Vue.prototype.$UploadAgreementDocument = 'sm/FileUpload/UploadAgreementDocument'
Vue.prototype.$DeleteAgreementDocument = 'common/Delete/AgreementDocument'
Vue.prototype.$UpdateAgreementDocument = 'common/Update/AgreementDocument'

Vue.prototype.$UploadApplicationGuideDocument = 'sm/FileUpload/UploadApplicationGuideDocument'
Vue.prototype.$UploadGeneralRequirementDocument = 'sm/FileUpload/UploadGeneralRequirementDocument'

Vue.prototype.$GetConfGeneral = 'common/ConfGeneral'

Vue.prototype.$GetAppAllowancesV4 = 'common/AppAllowance'

Vue.prototype.$ProgramTypeAll = 'common/programtypeall'

Vue.prototype.$AppSM = 'sa/app/sm'

Vue.prototype.$Allowances = 'common/Allowances'
Vue.prototype.$PaymentFrequency = 'common/paymentfrequency'
Vue.prototype.$StagInfo = 'sm/app/GetStagInformation'

Vue.prototype.$ProgramIdGREP = 10
Vue.prototype.$ProgramIdIESP = 13
Vue.prototype.$ProgramIdMESH = 17
Vue.prototype.$ProgramIdPROP = 11
Vue.prototype.$ProgramIdSKIPMA = 15
Vue.prototype.$ProgramIdSTEP = 16
Vue.prototype.$ProgramIdTESP = 14
Vue.prototype.$ProgramIdWTU = 12
Vue.prototype.$ProgramIdYTP = 1

Vue.prototype.$OfferLetterIntakeIdCutOff = 88
//Vue.prototype.$OfferLetterIntakeIdCutOff = 86

/* eslint-disable no-new */
export default
  new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {
      App
    },
    render: h => h(App),
  })